import React, { useEffect } from 'react'
import TextCaption from '../Components/TextCaption/TextCaption'
import SectionHeader from '../Components/SectionHeader/SectionHeader'
import CenterStage from '../Components/CenterStage/CenterStage'
import imgCodeofconduct from '../assets/Code of Conduct/Codeofconduct.jpg'

const Codeofconduct = () => {


  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on component mount
  }, []);


  return (
    <div>

      <CenterStage
        imageSrc={imgCodeofconduct}
        title={"Code of Conduct"}
        paragraph={"As a company, we are aware of our role in society and our responsibilities towards business partners and employees.Therefore, we are obliged to have clear principles, which serve as a guide for our business and social activities.We encourage our partners to implement similar business principles."}
      />

      <SectionHeader title="In accordance with our responsibilities, we are bound by the following principles." />

      <TextCaption
        title=""
        paragraph=""
        bulletPoints={[
          "We are a multinational company. For this reason, compliance with the laws and regulations of all the countries in which we operate is our highest priority. In situations not covered by any law, the values of our business concept and this code of conduct will be our basis.",
          "We see the prevention of risks to people and the environment, as well as the encouragement of alternatives, as essential components of responsible business behavior. Each of us is co-responsible for safety in our work area. All employees are sensitized and regularly trained in this regard.",
          "We consider environmentally conscious business activity not only an obligation, but also an important prerequisite for the conservation of natural resources.",
          "As a matter of principle, we treat both our business partners and employees with dignity and respect. We support and respect the protection of international human rights within our company and in working with our partners. We do not tolerate forced labor or child labor.",
          "We do not discriminate against anyone. We make no distinction regarding gender, religion, age, physical limitations, sexual orientation, nationality, political ideals, ethnicity, social class, or other personal characteristics.",
          "We do not consent to any kind of corruption and favoritism. In the context of our business activity, it is not permitted to demand, accept, offer or admit personal favor, gifts or invitations. The only exceptions are casual or promotional gifts, which respect the customs and courtesies of the country.",
          "In the course of our activity, we maintain political neutrality and do not support any political activity."
        ]}
      />
    </div>
  );
}

export default Codeofconduct;